







import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class SwitchToggle extends Vue {
  @Prop({ default: false })  isActivated: boolean;
  @Prop({ default: false })  switchId: string;
  @Prop({ default: false}) disabled: boolean;
  public isActivatedBool: boolean = false;


  onToggle() {
    this.$emit("toggle", !this.isActivatedBool);
  }

  created() {
    this.initIsActivatedBool();
  }

  @Watch("isActivated")
  initIsActivatedBool() {
    this.isActivatedBool = this.isActivated;
  }

}
